import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PopIptvCreateComponent } from 'src/app/components/pop-iptv-create/pop-iptv-create.component';

@Component({
  selector: 'app-iptv-create-account',
  templateUrl: './iptv-create-account.component.html',
  styleUrls: ['./iptv-create-account.component.sass']
})
export class IptvCreateAccountComponent implements OnInit {
public screen:number=Number(sessionStorage.getItem("PlanSelectionScreen") );
  public tabActive = 'Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public session: number;
  public content:object;
  public token: string = sessionStorage.getItem("token");
  public idPlan:string = sessionStorage.getItem("idPlan");
  signupForm: FormGroup
  constructor(public dialog: MatDialog,private active: ActivatedRoute,public AngularFireAnalytics: AngularFireAnalytics, public global: GlobalService, private router: Router,private loadingScreenService: LoadingScreenService, private builder:FormBuilder) {
    this.AngularFireAnalytics.setCurrentScreen("Netflix");
    this.AngularFireAnalytics.logEvent("Netflix-Screenview");
    this.createForm();
  }

  ngOnInit() {
    if(this.screen==0){
      this.screen=1;
    }
  }
  private createForm() {
        this.signupForm=this.builder.group({
      email:['',Validators.compose([Validators.email, Validators.required])]
    });
  }
  openPupUp(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { };
    const dialogRef = this.dialog.open(PopIptvCreateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
      if(value=="accept"){
        this.router.navigate(['iptv_confirmation']);
       }
    });
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  changeTab(idSession) {
    this.global.validateSession();
    this.session = idSession;
  }

  validador(){

    if (this.signupForm.get('email').status=="INVALID" || this.signupForm.get('email').hasError('required') || this.signupForm.get('email').value=="" )
    {
    this.global.notif(" Por favor, Ingresa un correo valido.");
    }
    else
    {
      this.openPupUp();
    }
  }
}
